<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // props
  export let height: number = 80;
  export let width: number = 80;
  export let heading: string;
  export let iconType: string;
  export let onCloseEnabled: boolean = true;
  export let onClose: () => void = () => {};
  export let color: "blue" | "green" | "red" = "blue";

</script>

<div
  class={`fizz-surface-${color} fizz-inset-square-24 fizz-flex-row fizz-align-content-start`}
  style="border-radius: 16px"
>
  <Icon type={iconType} {height} {width} />
  <div class="fizz-full-width">
    <h3 class="fizz-heading-3 fizz-stack-4">{heading}</h3>
    <slot />
  </div>
  {#if onCloseEnabled}
    <a href={"#"} on:click|preventDefault={onClose} data-testid="dismissable-button">
      <Icon width="12" height="12" type="X" className="fizz-icon-12 fizz-text-brand" />
    </a>
  {/if}
</div>
